import router from '@/router';
import axios from 'axios';
import Vue from 'vue';


//import myConfig from '@/myConfig';
console.log("Deneme,",process.env);
const $axios = axios.create({  
    baseURL:process.env.VUE_APP_APIURL+"/api/",
      withCredentials: true,
   // baseURL : 'https://localhost:7211/api/',
   timeout: 60000
 });


$axios.interceptors.response.use(
  response => response,
  error => {
    console.log("gdfgdfg",error);
    if (error.code === 'ECONNABORTED') {

       this.$toast.error("Sisteme Ulaşılamıyor.");

    }
        if (error.code === 'ERR_CONNECTION_REFUSED') {

       this.$toast.error("Sisteme Ulaşılamıyor.");

    }
 if (error.status === 401) {


  if (error.response.data && error.response.data.error){
    Vue.$toast.error(error.response.data.error);

  }
  else
  {
    Vue.$toast.error("Yetkiniz Bulunmamaktadır.");

  }

   


// if (router.currentRoute.path !== '/unauthorized') {
//   router.push('/unauthorized');
// }

   // router.push({ path: '/unauthorized' });
          
        }
    
    return Promise.reject(error);
  }
);


//axios.defaults.baseURL = 'https://localhost:7211/api/'

//   $axios.interceptors.request.use(

//     config => {

//      // console.log("myConfig:",myConfig.apiUrl);
//         let token = localStorage.getItem("loggedIn")
       
//         if (token) {
        
//             config.headers['Authorization'] = 'Bearer ' + token;
        
//         }
//          config.headers['Content-Type'] = 'application/json';
     
//         return config;
        

//     },
//     error => {
//         return Promise.reject(error);
//     }

//   );

//   $axios.interceptors.response.use((response) => {
//     return response;
// }, (error) => {
//         if (error.response.status === 401) {

//             return window.location.href = '/'
//         }

//     return Promise.reject(error);
// });

        // axios.get("https://localhost:44356/api/Degerlendirme/DegelendirmeKriterleri", {
        //     headers: {
        //         'Authorization': 'Bearer ' + state.token,
        //         'Content-Type' : 'application/x-www-form-urlencoded'
        //     }
        // })
        //     .then(response => {
        //         console.log(response);
        //         let data = response.data;
        //         for (let i in data) {
        //             data[i].key = i;
        //             commit("updateDegerlendirmekriterleriList", data[i]);
        //         }
        //     })
        //     .catch(e=> console.log(e))
        
export default $axios;

